import { NgTemplateOutlet } from '@angular/common';
import { Component, inject, OnDestroy, TemplateRef, contentChild } from '@angular/core';
import { UsuariosService } from '@modules/usuarios/services/usuarios.service';

@Component({
  selector: 'app-usuario-logado-info',
  imports: [NgTemplateOutlet],
  template: `
    <div class="relative flex h-full items-center">
      @if (usuarioService.usuarioLogado; as usuario) {
        <div class="animate-fade-in flex w-full flex-row gap-1">
          <ng-container [ngTemplateOutletContext]="{ $implicit: usuario }"
            [ngTemplateOutlet]="bodyTemplate()"
           />
        </div>
      } @else {
        <div class="animate-fade-in flex items-center space-x-2">
          <div
            class="h-4 w-4 animate-spin rounded-full border-2 border-gray-300 border-t-transparent"
          ></div>
          <span class="text-sm text-gray-500">Carregando...</span>
        </div>
      }
    
    </div>
    `,
  styles: [],
})
export class UsuarioLogadoInfoComponent implements OnDestroy {
  public isOpen = false;
  public readonly bodyTemplate = contentChild.required<TemplateRef<any>>('body');
  protected readonly usuarioService = inject(UsuariosService);

  ngOnDestroy(): void {
    console.log(`UsuarioLogadoInfoComponent OnDestroy`);
  }
}
